"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookAnchor = exports.BookButton = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const button_1 = __importStar(require("@kyruus/button"));
// BookButton and BookAnchor have the exact same styles, but factoring them out results in a prettier parsing error during snapshot testing
exports.BookButton = (0, styled_1.default)(button_1.default) `
  width: 100%;
  white-space: nowrap;
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  text-align: center;

  > span.button-text {
    font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_4')};
  }
`;
exports.BookAnchor = (0, styled_1.default)(button_1.ButtonLink) `
  width: 100%;
  white-space: nowrap;
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  text-align: center;

  > span.button-text {
    font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_4')};
  }
`;
//# sourceMappingURL=styles.js.map